// @ts-strict-ignore
import { ProjectHeadVO } from '@project/model/vo/project.vo';

export class FinalizationData {
  totalDemand: number;
  batchSize: number;
  deliveryDate: Date;
  sapProjectNumber: string;
  remarks: string;
  emailAddress: string;
  orderDirectly: boolean;
  additionalEmails: string[];
  projectsForMultipleRequest: ProjectHeadVO[];

  constructor(options?: {
    totalDemand: number;
    batchSize: number;
    deliveryDate: Date;
    sapProjectNumber: string,
    remarks: string;
    emailAddress: string;
    orderDirectly: boolean;
    additionalEmails: string[];
    projectsForMultipleRequest?: ProjectHeadVO[];
  }) {
    this.totalDemand = options.totalDemand;
    this.batchSize = options.batchSize;
    this.deliveryDate = options.deliveryDate;
    this.remarks = options.remarks;
    this.sapProjectNumber = options.sapProjectNumber;
    this.emailAddress = options.emailAddress;
    this.orderDirectly = options.orderDirectly;
    this.additionalEmails = options.additionalEmails;
    this.projectsForMultipleRequest = options.projectsForMultipleRequest ? options.projectsForMultipleRequest : null;
  }
}
